import { Tag } from 'api/api-rtk'

import type { CampaignStepType, StepExecution, StepHumanState } from './types'
import type { Step } from 'features/campaigns/types'

import { api } from './api'
import {
	type ContactQualification,
	QUALIFICATIONS,
	StepColor
} from './const'

const refetch = () => api.util.invalidateTags([Tag.Executions])

function colorByStep(state: StepHumanState, step?: StepExecution) {
	/**
	 * NotStarted step is a special case, it is colored by own color.
	 * All other steps are colored by execution state.
	 */
	if (step?.human_state === 'NotStarted') {
		return '#EBEDF2'
	}

	return StepColor[state]
}

function getStepTitle(stepState: StepHumanState, stepType: CampaignStepType): string {
	if (stepState === 'NotStarted') {
		return 'Not started'
	}

	if (stepState === 'InQueue') {
		return 'In queue'
	}

	if (stepState === 'InProgress') {
		if (stepType === 'Connect') {
			return 'Awaiting for connect'
		}

		if (stepType === 'Message') {
			return 'Awaiting for response'
		}

		return 'In Progress'
	}

	if (stepState === 'Succeed') {
		if (stepType === 'Connect') {
			return 'Connected'
		}

		return 'Responded'
	}

	if (stepState === 'Ignored') {
		if (stepType === 'Connect') {
			return 'Withdrawn'
		}

		return 'Not responded'
	}

	if (stepState === 'Cancelled') {
		return 'Cancelled by you'
	}

	if (stepState === 'Failed') {
		return 'System error'
	}

	if (stepState === 'Skipped') {
		return 'Skipped by system'
	}

	throw new Error(`Unsupported step state: ${stepState}`)
}

function getExecutionTitle(
	state: StepHumanState,
	steps?: Step[]
): string {
	if (state === 'Succeed') {
		const lastStepType = steps?.length
			? steps[steps.length - 1]?.type
			: undefined
		if (lastStepType === 'Connect') {
			return 'Connected'
		}
		return 'Responded'
	}

	if (state === 'NotStarted') {
		return 'Not started'
	}

	if (state === 'InQueue') {
		return 'In queue'
	}

	if (state === 'InProgress') {
		return 'In Progress'
	}

	if (state === 'Ignored') {
		return 'Not responded'
	}

	if (state === 'Cancelled') {
		return 'Cancelled by you'
	}

	if (state === 'Failed') {
		return 'System error'
	}

	if (state === 'Skipped') {
		return 'Skipped by system'
	}

	throw new Error(`Unsupported state: ${state}`)
}

const qualificationSet = new Set<ContactQualification>(QUALIFICATIONS)

const isQualification = (value: any) => qualificationSet.has(value)

export { colorByStep, getExecutionTitle, getStepTitle, isQualification, refetch }
